import { render } from "./MonetizationSideNav.vue.js?vue&type=template&id=366f2a6f!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./MonetizationSideNav.vue?vue&type=template&id=366f2a6f"
import script from "./MonetizationSideNav.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./MonetizationSideNav.vue?vue&type=script&lang=js"
export * from "./MonetizationSideNav.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./MonetizationSideNav.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Web/scripts/components/side-nav/MonetizationSideNav.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "366f2a6f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('366f2a6f', __exports__)) {
    api.reload('366f2a6f', __exports__)
  }
  
  module.hot.accept("./MonetizationSideNav.vue.js?vue&type=template&id=366f2a6f!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./MonetizationSideNav.vue?vue&type=template&id=366f2a6f", () => {
    api.rerender('366f2a6f', render)
  })

}


export default __exports__